import { render, staticRenderFns } from "./KETNewTrainer.vue?vue&type=template&id=189a032e&"
import script from "./KETNewTrainer.vue?vue&type=script&lang=js&"
export * from "./KETNewTrainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports